// @flow
import { transport } from "mmb/services/bookings/bookingsApi"
import type { MealSegmentsInput } from "mmb/records/mealsInput"

type PaymentPrice = {
  amount: string,
  currency: string,
}

export type PaymentData = {
  paid_by_card: {
    gate: "zooz" | "cup",
    price: PaymentPrice,
  },
  paid_by_credits: {
    price: PaymentPrice,
  },
}

export type ApiSelection = {
  option_code: string,
  passenger_id: number,
  segment_code: string,
}

export type MealsPostDataType = {
  booked_at: string,
  orig_price: string,
  payment: PaymentData,
  selections: Array<ApiSelection>,
}

export const fetchOrderMeals = (bid: number, payload: MealsPostDataType) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/meals`, null, payload)

export const fetchMealsOptions = (bid: number): Promise<MealSegmentsInput> =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/meals/options`, null)
